import src from "../../images/rafid_muhymin.jpg";

export default function About() {
  return (
    <main className="about mx-auto p-8 max-w-[768px] flex flex-col gap-4">
      <img
        className="img-fluid block mx-auto rounded-full"
        src={src}
        alt="Rafid Muhymin Wafi"
      />

      <h1
        className="my-3 text-center text-4xl text-[crimson]"
        style={{
          fontFamily: "Pacifico, sans-serif",
        }}
      >
        Rafid Muhymin Wafi
      </h1>

      {/* <p className="flex gap-1">
        <span className="block font-bold">Email Address: </span>
        <span className="text-[crimson] font-bold">
          rafidmuhymin@softhardsystem.com
        </span>
      </p>

      <p className="flex gap-1">
        <span className="block font-bold">Educational Background: </span>
        <span className="text-[crimson] font-bold">HSC 2023 Candidate</span>
      </p>

      <p className="flex gap-1">
        <span className="block font-bold">Skills: </span>
        <span className="text-[crimson] font-bold">
          Astro JS, React JS, Gatsby JS, JavaScript, Node.js, HTML & CSS,
          MD/MDX, Tailwind CSS, Bootstrap CSS, Preact, Svelte, Solid.js,
          Headless WordPress, Contentful
        </span>
      </p> */}

      <div class="overflow-x-auto drop-shadow-2xl">
        <table class="table w-full">
          <tbody>
            <tr>
              <td className="block font-bold">Email Address: </td>
              <td className="text-[crimson] font-bold">
                rafidmuhymin@softhardsystem.com
              </td>
            </tr>

            <tr>
              <td className="block font-bold">Educational Background: </td>
              <td className="text-[crimson] font-bold">HSC 2023 Candidate</td>
            </tr>

            <tr>
              <td className="block font-bold">Skills: </td>
              <td className="text-[crimson] font-bold">
                Astro JS, React JS, Gatsby JS, JavaScript, TypeScript, Node.js,
                Vite, Rollup, HTML & CSS, MD/MDX, Tailwind CSS, Bootstrap CSS,
                Preact, Svelte, Solid.js, Headless WordPress, Contentful
              </td>
            </tr>

            <tr>
              <td className="block font-bold">Projects: </td>
              <td className="font-bold">
                <a href="https://www.npmjs.com/package/astro-spa">
                  https://www.npmjs.com/package/astro-spa
                </a>
                ,{" "}
                <a href="https://www.npmjs.com/package/astro-imagetools">
                  https://www.npmjs.com/package/astro-imagetools
                </a>
                ,{" "}
                <a href="https://softhardsystem.com/">
                  https://softhardsystem.com/
                </a>
                ,{" "}
                <a href="https://muhymin.gatsbyjs.io/">
                  https://muhymin.gatsbyjs.io/
                </a>
                ,{" "}
                <a href="https://mahidtech.gatsbyjs.io/">
                  https://mahidtech.gatsbyjs.io/
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  );
}
